import { render } from "./SideForm.vue?vue&type=template&id=49eb6064"
import script from "./SideForm.vue?vue&type=script&lang=js"
export * from "./SideForm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__